import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Buildings } from "@phosphor-icons/react";

export const GRANULARITY = [
  { v: "daily", l: "Daily" },
  { v: "weekly", l: "Weekly" },
  { v: "445", l: "4-4-5 Period" },
  { v: "quarterly", l: "Quarterly" },
  { v: "ytd", l: "YTD" },
];

export default function GlobalContextBar({
  sites = [],
  siteId,
  onSiteChange,
  granularity,
  onGranularityChange,
  showLocationHub = true,
  showGranularity = true,
}) {
  const multiSite = sites.length > 1;
  return (
    <div
      className="flex items-center gap-6 flex-wrap"
      data-testid="global-context-bar"
    >
      {/* Granularity segmented control — top-left */}
      {showGranularity && (
        <div className="flex items-center bg-white border border-[#E2E8F0] rounded-md p-0.5" data-testid="granularity-segmented">
          {GRANULARITY.map((g) => (
            <button
              key={g.v}
              onClick={() => onGranularityChange(g.v)}
              data-testid={`gran-${g.v}`}
              className={`px-3.5 py-2 text-xs font-medium tracking-tight rounded transition-colors ${
                granularity === g.v
                  ? "bg-[#0F172A] text-white"
                  : "text-[#475569] hover:bg-[#EEEEEE]"
              }`}
            >
              {g.l}
            </button>
          ))}
        </div>
      )}

      {/* Location Hub */}
      {showLocationHub && multiSite && (
        <div className={`${showGranularity ? "ml-auto" : ""} flex items-center gap-2.5`} data-testid="location-hub">
          <Buildings size={14} weight="duotone" className="text-[#475569]" />
          <span className="uppercase text-[11px] tracking-[0.2em] text-[#475569] font-medium">Location</span>
          <Select value={siteId || "consolidated"} onValueChange={onSiteChange}>
            <SelectTrigger className="h-9 w-56 rounded-md text-xs bg-white border-[#E2E8F0]" data-testid="site-selector">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="consolidated" data-testid="site-option-consolidated">
                All Sites (Consolidated)
              </SelectItem>
              {sites.map((s) => (
                <SelectItem key={s.id} value={s.id} data-testid={`site-option-${s.id}`}>
                  {s.name}{s.location ? ` · ${s.location}` : ""}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
